export default __webpack_public_path__ + "static/study-2-small-f7941b6bfd21bc18d2e4be5050beef38.svg";